/**
 * Accessibility fixes for markup this theme does not author.
 *
 * Everything here exists because a third party injects DOM we cannot edit at
 * source. Anything we DO author should be fixed in the Liquid, not here.
 *
 * Created 2026-08-17 as part of the ADA remediation.
 * See plans/2026-08-14_ada-accessibility-remediation.md
 */
(function () {
  'use strict';

  /**
   * Google Customer Reviews badge (layout/theme.liquid, gapi ratingbadge,
   * merchant_id 1122632) renders an <iframe> with no title attribute, on every
   * page. A frame with no accessible name is announced as an unlabelled frame
   * and gives a screen-reader user nothing to decide with.
   *
   * axe rule: frame-title. WCAG 4.1.2 Name, Role, Value (Level A).
   */
  var GCR_TITLE = 'Google Customer Reviews rating';

  function titleGoogleBadgeFrames(root) {
    var frames = (root || document).querySelectorAll(
      'iframe:not([title]):not([aria-label]):not([aria-hidden="true"])'
    );
    for (var i = 0; i < frames.length; i++) {
      var f = frames[i];
      var src = f.getAttribute('src') || '';
      var id = f.getAttribute('id') || '';
      // gapi names its frames I0_<timestamp> and serves them from google.com.
      var isGoogleWidget = /(^|\.)google\.com/.test(src) || /^I\d+_/.test(id);
      if (isGoogleWidget) {
        f.setAttribute('title', GCR_TITLE);
      }
    }
  }


  /**
   * Announce filter results.
   *
   * The collection template does mark its product count with role="status", but
   * facets.js replaces that whole container on every filter change. A live region
   * that is removed and recreated does not announce: the browser only reads out
   * changes to a region that was already present. Measured 2026-08-17 on the
   * collection page, ticking a filter refreshed the grid in total silence, so a
   * screen-reader user had no way to know whether anything had happened or how
   * many products were left.
   *
   * The fix is a region that is created once, lives outside the replaced markup,
   * and is never torn down. A MutationObserver watches the count element and
   * copies its text across after each update.
   *
   * WCAG 4.1.3 Status Messages (Level AA).
   */
  function installFilterStatus() {
    var COUNT_SEL = '#ProductCountDesktop, #ProductCount, .product-count__text';
    var grid = document.getElementById('product-grid') ||
               document.getElementById('ProductGridContainer');
    if (!grid && !document.querySelector(COUNT_SEL)) return;

    var region = document.getElementById('a11y-filter-status');
    if (!region) {
      region = document.createElement('div');
      region.id = 'a11y-filter-status';
      region.setAttribute('role', 'status');
      region.setAttribute('aria-live', 'polite');
      region.setAttribute('aria-atomic', 'true');
      // Visually hidden, but not display:none, which would stop it announcing.
      region.style.cssText =
        'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;' +
        'clip:rect(0 0 0 0);white-space:nowrap;border:0;';
      document.body.appendChild(region);
    }

    var last = '';
    function announce() {
      var el = document.querySelector(COUNT_SEL);
      if (!el) return;
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text || text === last) return;   // don't repeat the same message
      last = text;
      region.textContent = text;
    }

    // Seed without announcing, so the first page load is silent.
    var seed = document.querySelector(COUNT_SEL);
    if (seed) last = (seed.textContent || '').replace(/\s+/g, ' ').trim();

    if (!('MutationObserver' in window)) return;
    var target = grid ? grid.parentNode || grid : document.body;
    new MutationObserver(function () { announce(); })
      .observe(target, { childList: true, subtree: true, characterData: true });
  }

  function start() {
    titleGoogleBadgeFrames(document);
    installFilterStatus();
    // The badge is injected asynchronously well after load, and gapi may
    // re-render it, so watch rather than run once.
    if (!('MutationObserver' in window)) return;
    var mo = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'IFRAME') {
            titleGoogleBadgeFrames(n.parentNode || document);
          } else if (n.querySelector && n.querySelector('iframe')) {
            titleGoogleBadgeFrames(n);
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
